import React from 'react'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../../templates/PrivatePageSF.js'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import DirectorListUI from '../../../components/finapp/kyc/DirectorListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const DirectorListPageUI = ({ context, messageList, errorList, directorList,
    onRefreshClick }) =>
  <PrivatePageSF context={context} className='pg_directors'
    messageList={messageList} headerMessageKey='c_kyc_verification'
    centered={(!directorList && !errorList) || (directorList && directorList.length === 0)}
  >
    {
      !directorList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      directorList &&
      <React.Fragment>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_kyc_verification'
        />
      </React.Fragment>
    }
    {
      directorList && directorList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={false}
        createDisabledMessageKey='c_no_dir_msg'
      />
    }
    {
      directorList && directorList.length !== 0 &&
      <DirectorListUI
        context={context}
        messageList={messageList}
        directorList={directorList}
        onRefreshClick={onRefreshClick}
      />
    }
  </PrivatePageSF>

export default DirectorListPageUI
